/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
// Styles
import './plugins/styles'

// Components
import App from './App.vue'
import * as Sentry from '@sentry/vue'
import { useThemeStore } from '@/stores/components/themeStore'

// Plugins
import { registerPlugins } from '@/plugins'
import router from '@/router'
import { useRouter } from 'vue-router'

import moment from 'moment/min/moment-with-locales'
moment.locale('pt-br')

// Composables
import { createApp } from 'vue'

const app = createApp(App)
app.use(router)

const isDev = ['development', 'local', 'dev'].includes(import.meta.env.VITE_ENVIRONMENT)


if(!isDev){
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      Sentry.replayCanvasIntegration(),
      Sentry.consoleLoggingIntegration({
        levels: ['error'],
      }),
    ],
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enableLogs: true,
    _experiments: { enableLogs: true },
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.sethtotal\.com\.br\/api/,
      /^https:\/\/homolog-api\.sethtotal\.com\.br\/api/,
    ],
    environment: import.meta.env.VITE_ENVIRONMENT ?? '',
  })
}

// Register Plugins
registerPlugins(app)

// --- INICIALIZAÇÃO DO TEMA ---
const themeStore = useThemeStore()
themeStore.initTheme()
// -----------------------------

app.mount('#app')
